import React from 'react';
import useStyles from './styles';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useScroll } from '@src/shared/hooks/use-scroll';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
const OverviewScroller = () => {
  const classes = useStyles();
  const { t } = useTranslation()
  const { scrollTopNative } = useScroll()
  const {isMobileDevice, isTablet} = useDeviceDetect()
  const sendScrollToThisElement = (elementSelector: string) => {
    const targetElement: HTMLElement | null =
      document.querySelector(elementSelector);
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - targetElement.offsetHeight,
        behavior: 'smooth',
      });
    }
  };

  const showScroller = (scrollTop: number) => {
    if (isMobileDevice || isTablet ) {
      return true
    } else if (scrollTop >= 275) {
      return true
    } else {
      return false
    }
  }


  return (
    showScroller(scrollTopNative) ? <div className={classes.scroller}>
      <Tooltip title={t('new_productoverview_common.scroller_go_to_top')} placement="right">
        <JetFontIcon
          iconname={JET_FONTICON_ALIASES.CHEVRON_UP}
          size={14}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        />
      </Tooltip>
      <div className="divider"></div>
      <Tooltip title={t('new_productoverview_courier.section5_title')} placement="right">
        <JetFontIcon
          iconname={JET_FONTICON_ALIASES.PLAY}
          size={20}
          onClick={() => sendScrollToThisElement('#section-5')}
        />
      </Tooltip>
      <div className="divider"></div>
      <Tooltip title={t('new_productoverview_common.section8_title')} placement="right">
        <JetFontIcon
          iconname={JET_FONTICON_ALIASES.CHAT_HELP}
          onClick={() =>
            sendScrollToThisElement('.faqcontent-questions-container')
          }
          size={19}
        />
      </Tooltip>
    </div> : <></>
  );
};

export default OverviewScroller;
